import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Pricing from "./pages/Pricing";
import Services from "./pages/Services";
import About from "./pages/About";
import Impressum from "./pages/impressum";
import SignUp from "./pages/SignUp";
import "./App.scss";
import { AppFooter } from "./Components/AppFooter";
import { AppHeader } from "./Components/AppHeader";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import LlmInfo from "./pages/LlmInfo";
import Labeling from "./pages/Labeling";
import AnomalyDetection from "./pages/AnomalyDetection";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import PopupContainer from "./Components/PopupContainer";
import { ScrollToTop } from "./Components/ScrollToTop";
import { useAnalytics } from "./hooks/useAnalytics";

const AppContent = () => {
  useAnalytics();

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/signup" element={<SignUp />} />
        <Route
          path="/"
          element={
            <>
              <AppHeader />
              <Home />
              <AppFooter />
            </>
          }
        />
        <Route
          path="/products/labeling"
          element={
            <>
              <AppHeader />
              <Labeling />
              <AppFooter />
            </>
          }
        />
        <Route
          path="/products/anomaly-detection"
          element={
            <>
              <AppHeader />
              <AnomalyDetection />
              <AppFooter />
            </>
          }
        />
        <Route
          path="/pricing"
          element={
            <>
              <AppHeader />
              <Pricing />
              <AppFooter />
            </>
          }
        />
        <Route
          path="/services"
          element={
            <>
              <AppHeader />
              <Services />
              <AppFooter />
            </>
          }
        />
        <Route
          path="/about"
          element={
            <>
              <AppHeader />
              <About />
              <AppFooter />
            </>
          }
        />
        <Route
          path="/blog"
          element={
            <>
              <AppHeader />
              <Blog />
              <AppFooter />
            </>
          }
        />
        <Route
          path="/blog/:slug"
          element={
            <>
              <AppHeader />
              <BlogPost />
              <AppFooter />
            </>
          }
        />
        <Route
          path="/impressum"
          element={
            <>
              <AppHeader />
              <Impressum />
              <AppFooter />
            </>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <>
              <AppHeader />
              <PrivacyPolicy />
              <AppFooter />
            </>
          }
        />
        <Route
          path="/terms"
          element={
            <>
              <AppHeader />
              <Terms />
              <AppFooter />
            </>
          }
        />
        <Route
          path="/cookie-policy"
          element={
            <>
              <AppHeader />
              <CookiePolicy />
              <AppFooter />
            </>
          }
        />
        <Route
          path="/llm-info"
          element={
            <>
              <AppHeader />
              <LlmInfo />
              <AppFooter />
            </>
          }
        />
      </Routes>
      <PopupContainer />
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
